"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_EXTS = exports.UNSUPPORTED_VIDEO_FORMAT = exports.SUPPORTED_NON_VIDEO_EXTS = exports.SUPPORTED_FILE_SIZE = exports.SOURCE_MAX_UPLOAD_COUNT = exports.SOURCE_MAX_FILE_SIZE_MULTIPART = exports.SOURCE_MAX_FILE_SIZE = exports.PDF_EXTS = exports.NOT_ADVERTISED_VIDEO_EXTS = exports.MEDIA_UPLOAD_ACTION = exports.MEDIA_REMOVAL_ACTION = exports.IMAGE_EXTS = exports.DEFAULT_EXTENSIONS = exports.AUDIO_EXTS = exports.ADVERTISED_VIDEO_EXTS = exports.ADDITIONAL_VIDEO_EXTS = void 0;
/**
 * 2GB of file size value in kilobyte
 */
var SUPPORTED_FILE_SIZE = exports.SUPPORTED_FILE_SIZE = 2 * 1000 * 1024 * 1024;
var SOURCE_MAX_FILE_SIZE = exports.SOURCE_MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024;
var SOURCE_MAX_FILE_SIZE_MULTIPART = exports.SOURCE_MAX_FILE_SIZE_MULTIPART = 40 * 1024 * 1024; // 40MB

var SOURCE_MAX_UPLOAD_COUNT = exports.SOURCE_MAX_UPLOAD_COUNT = 5;
var MEDIA_REMOVAL_ACTION = exports.MEDIA_REMOVAL_ACTION = 'Media File Removed';
var MEDIA_UPLOAD_ACTION = exports.MEDIA_UPLOAD_ACTION = 'Media File Uploaded';
var ADVERTISED_VIDEO_EXTS = exports.ADVERTISED_VIDEO_EXTS = ['.m4v', '.mov', '.avi', '.webm', '.mpg'];

/** We support this, but we just don't show this in the UI */
var NOT_ADVERTISED_VIDEO_EXTS = exports.NOT_ADVERTISED_VIDEO_EXTS = ['.wmv', '.mpeg', '.mpg2', '.mpe', '.mpv', '.qt'];
var VIDEO_EXTS = exports.VIDEO_EXTS = ['.mp4'];
var ADDITIONAL_VIDEO_EXTS = exports.ADDITIONAL_VIDEO_EXTS = ['.mov', '.webm'];
var IMAGE_EXTS = exports.IMAGE_EXTS = ['.jpg', '.jpeg', '.png', '.gif'];
var AUDIO_EXTS = exports.AUDIO_EXTS = ['.mp3', '.wav'];
var PDF_EXTS = exports.PDF_EXTS = ['.pdf'];
var DEFAULT_EXTENSIONS = exports.DEFAULT_EXTENSIONS = [].concat(VIDEO_EXTS, IMAGE_EXTS, AUDIO_EXTS, PDF_EXTS);
var SUPPORTED_NON_VIDEO_EXTS = exports.SUPPORTED_NON_VIDEO_EXTS = [].concat(IMAGE_EXTS, AUDIO_EXTS, PDF_EXTS);

/**
 * h.265 codecs are not supported by all browsers
 */
var UNSUPPORTED_VIDEO_FORMAT = exports.UNSUPPORTED_VIDEO_FORMAT = ['HEVC'];